document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('form[data-variants]');
  if (!forms.length) return;

  forms.forEach(function(form) {
    var variantIds, variantOptions, variantAvailability;
    try {
      variantIds = JSON.parse(form.dataset.variants);
      variantOptions = JSON.parse(form.dataset.options);
      variantAvailability = JSON.parse(form.dataset.availability);
    } catch (e) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('Product form: invalid variant data', e);
      }
      const fallbackButton = form.querySelector('.add-to-cart');
      if (fallbackButton) fallbackButton.disabled = true;
      return;
    }

    if (!Array.isArray(variantIds) || !Array.isArray(variantOptions) || !variantAvailability || typeof variantAvailability !== 'object') {
      const fallbackButton = form.querySelector('.add-to-cart');
      if (fallbackButton) fallbackButton.disabled = true;
      return;
    }

    const addToCartBtn = form.querySelector('.add-to-cart');
    const optionCount = Array.isArray(variantOptions[0]) ? variantOptions[0].length : 0;

    function getOptionIndex(input, fallbackIndex) {
      const dataIndex = input.getAttribute('data-option-index');
      if (dataIndex !== null && dataIndex !== '') {
        const parsedDataIndex = parseInt(dataIndex, 10);
        if (!Number.isNaN(parsedDataIndex)) return parsedDataIndex;
      }

      const nameMatch = (input.getAttribute('name') || '').match(/option-(\d+)-/);
      if (nameMatch) return Number(nameMatch[1]) - 1;

      return fallbackIndex;
    }

    function getSelectedOptions() {
      const selectedOptions = Array(optionCount).fill('');

      const checkedRadios = Array.from(form.querySelectorAll('input.product-variant-input[type=radio]:checked'));
      checkedRadios.forEach(function(radio, fallbackIndex) {
        const optionIndex = getOptionIndex(radio, fallbackIndex);
        if (optionIndex >= 0 && optionIndex < optionCount) {
          selectedOptions[optionIndex] = radio.value.trim();
        }
      });

      const selects = Array.from(form.querySelectorAll('select.product-variant-input, select.product-option-select, select[name^="option-"]'));
      selects.forEach(function(select, fallbackIndex) {
        const optionIndex = getOptionIndex(select, fallbackIndex);
        if (optionIndex >= 0 && optionIndex < optionCount) {
          selectedOptions[optionIndex] = select.value.trim();
        }
      });

      return selectedOptions;
    }

    function hasMatchingAvailableVariant(selectedOptions) {
      return variantOptions.some(function(variantOpts, index) {
        const variantId = variantIds[index];
        if (!variantAvailability[variantId]) return false;

        return variantOpts.every(function(variantOptionValue, optionIndex) {
          const selectedOptionValue = selectedOptions[optionIndex];
          if (!selectedOptionValue) return true;
          return variantOptionValue === selectedOptionValue;
        });
      });
    }

    function findMatchingVariantIndex(selectedOptions) {
      return variantOptions.findIndex(function(variantOpts) {
        return variantOpts.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function findFirstAvailableVariantIndex() {
      return variantIds.findIndex(function(variantId) {
        return !!variantAvailability[variantId];
      });
    }

    function applyVariantSelection(variantIndex) {
      const optionValues = variantOptions[variantIndex];
      if (!Array.isArray(optionValues)) return;

      optionValues.forEach(function(optionValue, optionIndex) {
        const optionRadioInputs = Array.from(form.querySelectorAll('input.product-variant-input[type=radio]')).filter(function(input, fallbackIndex) {
          return getOptionIndex(input, fallbackIndex) === optionIndex;
        });
        const matchingRadio = optionRadioInputs.find(function(input) {
          return input.value.trim() === optionValue;
        });
        if (matchingRadio) {
          matchingRadio.checked = true;
        }

        const optionSelects = Array.from(form.querySelectorAll('select.product-variant-input, select.product-option-select, select[name^="option-"]')).filter(function(select, fallbackIndex) {
          return getOptionIndex(select, fallbackIndex) === optionIndex;
        });
        optionSelects.forEach(function(select) {
          select.value = optionValue;
        });
      });
    }

    function updateOptionAvailability() {
      const selectedOptions = getSelectedOptions();
      const radioInputs = Array.from(form.querySelectorAll('input.product-variant-input[type=radio]'));
      const radioGroups = new Map();

      radioInputs.forEach(function(input, fallbackIndex) {
        if (input.hasAttribute('data-variant-fixed')) return;

        const optionIndex = getOptionIndex(input, fallbackIndex);
        if (optionIndex < 0 || optionIndex >= optionCount) return;

        const nextSelectedOptions = selectedOptions.slice();
        nextSelectedOptions[optionIndex] = input.value.trim();

        const isAvailableChoice = hasMatchingAvailableVariant(nextSelectedOptions);

        // Keep OOS options selectable so Notify Me / sold-out UI can target that variant.
        const radioContainer = input.closest('.radio-container');
        if (radioContainer) {
          radioContainer.classList.toggle('option-unavailable', !isAvailableChoice);
        }

        if (!radioGroups.has(input.name)) {
          radioGroups.set(input.name, []);
        }
        radioGroups.get(input.name).push(input);
      });

      radioGroups.forEach(function(groupInputs) {
        const interactiveInputs = groupInputs.filter(function(input) {
          return !input.hasAttribute('data-variant-fixed');
        });
        if (!interactiveInputs.length) return;

        const hasCheckedInput = interactiveInputs.some(function(input) {
          return input.checked;
        });
        if (hasCheckedInput) return;

        interactiveInputs[0].checked = true;
      });

    }

    function syncColorOptionCurrentValues() {
      const colorOptionFieldsets = Array.from(form.querySelectorAll('[data-color-option]'));
      colorOptionFieldsets.forEach(function(fieldset) {
        const currentValueElement = fieldset.querySelector('[data-color-option-current]');
        if (!currentValueElement) return;

        const checkedColorInput = fieldset.querySelector('input.product-variant-input[type=radio]:checked');
        if (!checkedColorInput) return;

        currentValueElement.textContent = checkedColorInput.value.trim();
      });
    }

    function updateVariantId() {
      updateOptionAvailability();
      // Run a second pass so option states reflect any auto-selected fallback values.
      updateOptionAvailability();
      let selectedOptions = getSelectedOptions();
      let matchingVariantIndex = findMatchingVariantIndex(selectedOptions);
      const hasAnyAvailableVariant = variantIds.some(function(variantId) {
        return !!variantAvailability[variantId];
      });
      const variantInput = form.querySelector('.product-variant-id');

      if (!hasAnyAvailableVariant) {
        if (variantInput) variantInput.value = '';
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('sold-out');
          addToCartBtn.textContent = 'Sold out';
        }
        return;
      }

      if (matchingVariantIndex === -1) {
        const firstAvailableVariantIndex = findFirstAvailableVariantIndex();
        if (firstAvailableVariantIndex !== -1) {
          applyVariantSelection(firstAvailableVariantIndex);
          updateOptionAvailability();
          updateOptionAvailability();
          selectedOptions = getSelectedOptions();
          matchingVariantIndex = findMatchingVariantIndex(selectedOptions);
        }
      }

      const hasCompleteSelection = selectedOptions.length === optionCount && selectedOptions.every(function(optionValue) {
        return optionValue !== '';
      });

      if (matchingVariantIndex !== -1) {
        const variantId = variantIds[matchingVariantIndex];
        if (variantInput) variantInput.value = variantId;
        if (addToCartBtn) {
          if (!variantAvailability[variantId]) {
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add('sold-out');
            addToCartBtn.textContent = 'Sold out';
          } else {
            addToCartBtn.disabled = false;
            addToCartBtn.classList.remove('sold-out');
            addToCartBtn.textContent = 'Add to cart';
          }
        }
      } else {
        if (variantInput) variantInput.value = '';
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          if (hasCompleteSelection) {
            addToCartBtn.classList.add('sold-out');
            addToCartBtn.textContent = 'Sold out';
          } else {
            addToCartBtn.classList.remove('sold-out');
            addToCartBtn.textContent = 'Add to cart';
          }
        }
      }

      syncColorOptionCurrentValues();
    }

    form.addEventListener('change', function (e) {
      if (
        e.target.matches('input[type=radio]') ||
        e.target.matches('select')
      ) {
        updateVariantId();
      }
    });

    updateVariantId();
  });
});